import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadTicketArticleGetDataRequest } from "../redux/Actions";
import Modalpopup from "../../../../shared/components/Modalpopup";
import ArticleList from "../../../vision_hub/articleList/components/ArticleList";

const TicketArticle = ({ values, setFieldValue,articleID }) => {
  const dispatch = useDispatch();
  const { article } = useSelector((state) => state.ticketing);
  const[showModal, setShowModal] = useState(false);
  const [selectedLink, setSelectedLink] = useState("");
  const [showArticleModal, setShowArticleModal] = useState(false);


  useEffect(() => {
    if (articleID) {
      dispatch(loadTicketArticleGetDataRequest(articleID));
    }
  }, [articleID, dispatch]);

  const category = values?.category;
  console.log("CAte",category);

  return (
    <>
    <div style={{ padding: "15px" }}>  
      {/* SEARCH ARTICLE — RIGHT SIDE */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3 style={{ marginBottom: "0", fontWeight: "600" }}>
          {article?.title}
        </h3>

        <span
          onClick={() => setShowArticleModal(true)}
          style={{
            color: "#0056b3",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: "6px"
          }}
        >
          <i className="fas fa-search"></i>  {/* Search icon */}
          Search Article
        </span>
      </div>
      
      {/* ---------- EXTERNAL LINKS ---------- */}
      {article?.external_link?.length > 0 && (
        <div style={{ marginBottom: "20px" }}>
          <h5 style={{ marginBottom: "10px" }}>External Links</h5>
          {article.external_link.map((link, index) => (
            <div key={index}>
              <span
                onClick={() => {
                  setSelectedLink(link);
                  setShowModal(true);
                }}
                style={{ 
                  color: "#0056b3", 
                  textDecoration: "underline", 
                  cursor: "pointer" 
                }}
              >
                {link}
              </span>
            </div>
          ))}
        </div>
      )}


      {/* ---------- MAIN HTML CONTENT ---------- */}
      {article?.content && (
        <div
          style={{
            padding: "15px",
            border: "1px solid #ddd",
            borderRadius: "6px",
            backgroundColor: "#fff",

            /*  Important UI fixes */
            maxHeight: "400px",        // adjust height as needed
            overflowY: "auto",
            overflowX: "hidden",
            wordBreak: "break-word",
            whiteSpace: "normal"
          }}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      )}

    </div>

    <Modalpopup show={showModal} handleClose={() => setShowModal(false)}   actionTitle={article?.external_link}   size="lg">
       {selectedLink && (
        <iframe
          src={selectedLink}
          style={{ width: "100%", height: "80vh", border: "none" }}
          title="External File"
        />
       )}
     </Modalpopup> 
     <Modalpopup  show={showArticleModal}  handleClose={() => setShowArticleModal(false)}  actionTitle="Search Articles"  size="xl">
      <ArticleList category={values?.category} onSelect={(item) => {
          // When article is selected from ArticleList
          setFieldValue("article_id", item.id);
          setShowArticleModal(false);
        }}
      />
    </Modalpopup>

  </>
  );
};

export default TicketArticle;
